import Select from "@mui/material/Select";
import { ComponentProps } from "../types";
import { CSSProperties, useMemo, useContext, useState, useEffect } from "react";
import DashboardPageContext from "../DashboardPageContext";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import { MenuItem, TextFieldVariants } from "@mui/material";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const [value, setValue] = useState<string | number>();

	useEffect(() => {
		const value = evaluteScript(component.properties["binding"]) as string | number;
		setValue(value);
	}, [component, pageContext.context, evaluteScript]);

	const options = useMemo(() => {
		const options = evaluteScript(component.properties["options"]) as Array<unknown>;
		if (options) {
			return options.map((option) => {
				// options is used inside the eval process
				return { value: eval(component.properties["optionValue"]) as string | number, label: eval(component.properties["optionLabel"]) as string | number };
			});
		} else return undefined;
	}, [pageContext.context]);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["width"]) style.width = component.properties["width"];
		return style;
	}, [component, exeMode]);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		args["variant"] = (component.properties["variant"] || undefined) as TextFieldVariants;
		if (component.properties["label"]) args["label"] = component.properties["label"];
		if (component.properties["placeholder"]) args["placeholder"] = component.properties["placeholder"];
		if (component.properties["focused"] && component.properties["focused"] !== "Initial") {
			args["focused"] = component.properties["focused"] === "True" ? true : false;
		}
		if (component.properties["fullWidth"] && component.properties["fullWidth"] !== "Initial") {
			args["fullWidth"] = component.properties["fullWidth"] === "True" ? true : false;
		}
		args["size"] = component.properties["size"] || "medium";
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);

	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);

	return (
		<>
			<Select
				// I don't know why this is happening, the component won't rerender on page reload !
				key={value}
				value={value}
				style={style}
				{...args}
				onChange={(event) => {
					const script = component.properties["binding"] + "=" + (event.target.value != undefined ? "`" + String(event.target.value).replace(/`/g, "\\`") + "`" : "undefined");
					evaluteScript(script);
					pageContext.updateContext(pageContext.context);
				}}
			>
				{(component.properties["allowEmptyOption"] || "True") === "True" && <MenuItem>{component.properties["emptyOptionLabel"]}</MenuItem>}
				{options &&
					options.length > 0 &&
					options.map((option, i) => (
						<MenuItem key={i} value={option.value}>
							{option.label}
						</MenuItem>
					))}
			</Select>
		</>
	);
}

export default Component;
